module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$route.meta.noHeader) ? _c('div', {
    staticClass: "sd-header-wrapper"
  }, [(_vm.showAnnouncement) ? _c('announcement', {
    on: {
      "close": function($event) {
        _vm.showAnnouncementSetter(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sd-header"
  }, [_c('div', {
    staticClass: "sd-title-container"
  }, [(!_vm.$route.meta.login && !_vm.$route.meta.token) ? _c('div', {
    staticClass: "sd-buttons-line"
  }, [(_vm.$route.params.key &&
    (_vm.$route.meta.jira || _vm.$route.meta.confluence)) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.redirectHome(_vm.routeKey)
      }
    }
  }, [_c('a', [_vm._v("Suche")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.key) ? _c('span', [_c('a', {
    staticClass: "sd-button-announcement",
    on: {
      "click": function($event) {
        _vm.showAnnouncementSetter(true)
      }
    }
  }, [_vm._v("\n            Ankündigung\n          ")])]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Ausloggen")]), _vm._v(" "), _c('div', {
    staticClass: "sd-user-wrapper"
  }, [_vm._v("\n          " + _vm._s(_vm.userNameDisplay) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.redirectHome(_vm.routeKey)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icon.png",
      "height": "40",
      "width": "40"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "sd-page-title",
    on: {
      "click": function($event) {
        _vm.redirectHome(_vm.routeKey)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pageName) + "\n      ")])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bad0b5d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/childs/Header.vue
// module id = 420
// module chunks = 1